import axios from "axios";
import instance from "@/services/axios";

export function getToken() {
  return axios
    .post(process.env.VUE_APP_SERVER + "/rhenium/api", {
      operationName: "LoginMfa",
      variables: {
        form: {
          password: {
            account: "jxsw-admin",
            password: "Jxsw123!",
          },
          sms: {
            id: "13700000000",
            mobile: "13700000000",
            code: "1234",
          },
        },
      },
      query: `mutation LoginMfa($form: ILogin!) {  login_mfa(form: $form)}`,
    })
    .then((res) => res.data.data);
}

export function getModelToken() {
  return axios
    .post("http://10.200.0.25:9012/jxsw/api", {
      operationName: "LoginMfa",
      variables: {
        form: {
          password: {
            account: "admin",
            password: "Jxsw@2024",
          },
          sms: {
            id: "13700000000",
            mobile: "13700000000",
            code: "1234",
          },
        },
      },
      query: `mutation LoginMfa($form: ILogin!) {  login_mfa(form: $form)}`,
    })
    .then((res) => res.data.data);
}

export function getDmas() {
  return instance.post("rhenium/api", {
    operationName: "GetDmas",
    variables: {
      query: {
        levels: [0],
      },
    },
    query: `query GetDmas($query: QDma!) {  dmas(query: $query) {    id    level    parent    status    area    square    pipe    altitude    mode    built    supply    pop    nfilter    cust    weight    o_station {      id      code      model      name      area      addr      position      position_type      weight      type      time      l6: sensor(unit: "L6") {        t0: o_day(offset: 0) {          value          acc        }        t1: o_day(offset: -1) {          value          acc        }        t2: o_day(offset: -2) {          value          acc        }      }      sensors {        id        name        unit        o_unit {          unit        }        o_realtime {          value          time        }      }    }    o_dma_topos {      id      station      type      o_station {        id        name        code        type        area        o_area {          name        }        factory: o_station_factory {          use          id        }        position        position_type        weight        model        time        sensors {          id          name          unit          o_realtime {            value            time          }        }      }    }  }}`,
  });
}

export function getDashboard() {
  return instance.post("rhenium/api", {
    operationName: "Dashboard",
    variables: {},
    query: `query Dashboard {  dashboard {    dmas {      id      square      pipe      cust      flow      piezo      vip      station      o_station {        position   position_type     name        id      }      l1: sensor(unit: "L1") {        today: o_day(offset: 0) {          value        }      }      l6: sensor(unit: "L6") {        yes0: o_day(offset: 0) {          acc        }        yes1: o_day(offset: -1) {          acc        }        yes2: o_day(offset: -2) {          acc        }      }      l7: sensor(unit: "L7") {        yes0: o_day(offset: 0) {          acc        }        yes1: o_day(offset: -1) {          acc        }        yes2: o_day(offset: -2) {          acc        }      }      l10: sensor(unit: "L10") {        yes0: o_day(offset: 0) {          acc        }        yes1: o_day(offset: -1) {          acc        }        yes2: o_day(offset: -2) {          acc        }      }      l11: sensor(unit: "L11") {        yes0: o_day(offset: 0) {          acc        }        yes1: o_day(offset: -1) {          acc        }        yes2: o_day(offset: -2) {          acc        }      }      l12: sensor(unit: "L6") {        o_day(offset: 0) {          acc        }      }      l2: sensor(unit: "L6") {        o_day(offset: -1) {          acc        }      }      l3: sensor(unit: "L6") {        o_day(offset: -2) {          acc        }      }      area      children {        id        area        id        square        pipe        cust        flow        piezo        vip        station        o_station {          name          id          position    position_type    }        area        l1: sensor(unit: "L1") {          today: o_day(offset: 0) {            value          }        }        l6: sensor(unit: "L6") {          yes0: o_day(offset: 0) {            acc          }          yes1: o_day(offset: -1) {            acc          }          yes2: o_day(offset: -2) {            acc          }        }        l7: sensor(unit: "L7") {          yes0: o_day(offset: 0) {            acc          }          yes1: o_day(offset: -1) {            acc          }          yes2: o_day(offset: -2) {            acc          }        }        l10: sensor(unit: "L10") {          yes0: o_day(offset: 0) {            acc          }          yes1: o_day(offset: -1) {            acc          }          yes2: o_day(offset: -2) {            acc          }        }        l11: sensor(unit: "L11") {          yes0: o_day(offset: 0) {            acc          }          yes1: o_day(offset: -1) {            acc          }          yes2: o_day(offset: -2) {            acc          }        }        l12: sensor(unit: "L6") {          o_day(offset: 0) {            acc          }        }        l2: sensor(unit: "L6") {          o_day(offset: -1) {            acc          }        }        l3: sensor(unit: "L6") {          o_day(offset: -2) {            acc          }        }      }    }    availability {      dma      stat      stat_all      stat_err      vip      vip_all      vip_err      flowmeter      flowmeter_all      flowmeter_err      piezometer      piezometer_all      piezometer_err    }    illegal    detected    leakable    checkable    battery    accuracy {      year      accuracy    }    benifit {      benifit      grow    }    leaks {      id      detected      reported      ratio      o_dma {        id        o_station {          name        }      }    }    ticket {      types {        id        type {          name        }        sums      }      months {        month        assigned        done        timely        done      }    }    leak_months {      year      month      reported      detected      ratio    }  }}`,
  });
}

export function getMonitors(types = ["D01", "D02", "D03"]) {
  return instance.post("rhenium/api", {
    operationName: "GetMonitors",
    variables: {
      query: {
        keyword: null,
        area: null,
        page: 1,
        limit: 999,
        count: true,
        mtypes: types,
        alarming: 0,
      },
    },
    query: `query GetMonitors($query: QMonitor!) {  monitors(query: $query) {    size    total    data {      id      dma      station      mtype      roles      o_station {        cmmid        id        code        name        type        area        addr        position  position_type      time        online        events {          o_alarm_sensor {            o_source {              id            }            o_alarm {              low              high              type              expression            }          }        }        devices {          code          cmmid        }        o_area {          name          area        }        sensors {          id          channel          unit          name          required          o_unit {            unit            name          }          o_realtime {            id            time            value          }        }      }    }  }}`,
  });
}

export function getVIP() {
  return instance.post("rhenium/api", {
    operationName: "GetVips",
    variables: {
      query: {
        limit: 999,
        page: 1,
        count: true,
        viptype: 1,
        type: "D02",
        category: null,
        area: null,
        dma: null,
      },
    },
    query: `query GetVips($query: QVIP!) {  vips(query: $query) {    size    total    data {      id      dma      station      type      stime      suid      o_suser {        name      }      saddr      dma      category      compara      o_compara {        o_device {          code        }      }      limit      o_dma {        id        o_station {          name        }      }      stype      direction      sphoto      status      weight      created      changed      flow      o_station {        id        name        code        type        area        position        position_type        addr        model        altitude        depth        weight        time        o_area {          name        }        o_model {          name        }        sensors {          id          name          unit          o_realtime {            value            time          }        }      }      o_flowmeter {        id        sdate        caliber        smmodel        bottom        category        o_smmodel {          model        }        o_device {          code        }      }    }  }}`,
  });
}

export function getStations(params) {
  return instance.post("rhenium/api", {
    operationName: "GetSecondarys",
    variables: {
      query: {
        limit: 999,
        page: 1,
        count: true,
        types: params.types,
      },
    },
    query: `query GetSecondarys($query: QStation!) {  secondarys: stations(query: $query) {    size    total    data {      id      name      time      code      position   position_type   type      artifact      sensors {        id        name        unit        o_unit {          id          unit          name        }        o_realtime {          time          value        }      }      devices {        id        name        time        cmmid        sensors {          id          name          unit          o_unit {            voption          }        }      }      o_videos {        id        type        station        addr        position        app_key        app_secret        main        sub        status        weight        created        changed      }    }  }}`,
  });
}

export function getHistory(params) {
  return instance.post("rhenium/api", {
    operationName: "GetHistory",
    variables: {
      query: {
        etime: params.etime,
        stime: params.stime,
        sensors: [params.id],
        interval: params.interval,
        fill_option: "null",
      },
    },
    query: `query GetHistory($query: QData!) {  history: datas(query: $query) {    id    o_sensor {      id      name      unit      o_unit {        voption        cycle        id        name        unit        type        dim        o_dim {          name          max          min        }      }      o_station {        name        id        dma {          id        }      }      o_device {        name        id      }    }    values {      time      value    }  }}`,
  });
}

export function getEvents(params) {
  return instance.post("rhenium/api", {
    operationName: "GetEvents",
    variables: {
      query: {
        etime: params.etime,
        stime: params.stime,
        levels: params.level,
        state: "closed",
        page: 1,
        limit: 0,
        count: true,
      },
    },
    query: `query GetEvents($query: QEvents!) {  events(query: $query) {    total  }}`,
  });
}

export function getYears() {
  return instance.post("rhenium/api", {
    operationName: "GetYears",
    variables: {
      query: {
        page: 1,
        limit: 5,
        count: false,
      },
    },
    query: `query GetYears($query: QLeakageYear!) {  leakage_years(query: $query) {    size    total    data {      id      corp      year      supply      sale      leak      nrw    }  }}`,
  });
}

export function getStation(id) {
  return instance.post("jxsw/api", {
    operationName: "GetStation",
    variables: {
      id: id,
    },
    query: `query GetStation($id: String!) {
    station(id:$id) {
        id
        code
        name
        o_area {
            id
            name
        }      
        devices {
            id
            name
            code
            online
            time
            o_model {
                id
                name
            }
            sensors {
                id
                name
                unit
                o_unit {
                    unit
                    precision
                }
                o_realtime {
                    time
                    value
                }
            }
            attributes {
                ... on DeviceUnit {
                    id
                    o_workshop {
                        id
                        name
                    }
                }
            }
        }
    }
}
    `,
  });
}

export function getStationResidents() {
  return instance.post("rhenium/api", {
    operationName: "station_residents",
    variables: {},
    query: `query station_residents {  dmas(query: {levels: [3], cbjs: 1}) {    id    area    o_station {      name      area      position   position_type }    parent  }  station_resident_dma_stats(query: {}) {    total    items {      total      id    }  }}`,
  });
}

export function getListDmas() {
  return instance.post("rhenium/api", {
    operationName: "ListDmas",
    variables: {
      query: {
        levels: [3],
      },
    },
    query: `query ListDmas($query: QDma!) {  dmas(query: $query) {    id    o_station { id name area o_area {        name      }      position  position_type  }  }}`,
  });
}

export function GetStation_residents(params) {
  return instance.post("rhenium/api", {
    operationName: "GetStation_residents",
    variables: {
      query: {
        limit: 20,
        page: params.page,
        count: true,
        dma: params.id,
        area: null,
      },
    },
    query: `query GetStation_residents($query: QStationResident!) {  station_residents(query: $query) {    size    total    data {      id      dma      station      type      stime      suid      saddr      dma      category      flow      o_dma {        id        o_station {          name        }      }      stype      direction      sphoto      status      weight      created      changed      o_station {        id        name        code        type        area        position        position_type        addr        model        weight        time        o_area {          name        }        sensors {          id          name          unit          o_realtime {            value            time          }        }      }      o_flowmeter {        id        sdate        caliber        smmodel        bottom        o_smmodel {          model        }        o_device {          code        }      }    }  }}`,
  });
}

export function getFlowmeter() {
  return instance.post("rhenium/api", {
    operationName: "GetDmas",
    variables: {
      query: {
        levels: [1],
      },
    },
    query: `query GetDmas($query: QDma!) {  dmas(query: $query) {    o_dma_topos{      o_station{        id        name        position      }    }  }}`,
  });
}

export function getPois() {
  return instance.post("rhenium/api", {
    operationName: "GetPois",
    variables: {
      query: {
        limit: 9999999,
        page: 1,
        count: true,
      },
    },
    query:
      "query GetPois($query: QPoi!) {\n  pois(query: $query) {\n    size\n    total\n    data {\n      id\n      name\n      photo\n      tid\n      addr\n      position\n      position_type\n      remark\n      o_type {\n        name\n        icon\n      }\n      created\n      changed\n    }\n  }\n}\n",
  });
}

export function getDma(id) {
  return instance.post("rhenium/api", {
    operationName: "GetDma2",
    variables: {
      id: id,
    },
    query: `query GetDma2($id: String!) {  dma(id: $id) {    id    level    parent    square    pipe    cust    altitude    mode    built    supply    pop    demand    occupancy    nfilter    status    weight    resident_pcount(month: 0)    created    changed    o_station {      id      code      model      name      area      addr      position      weight      time      type      sensors {        id        name        unit        o_realtime {          value          time        }        y_acc: o_day(offset: -1) {          acc          value        }        t_acc: o_day(offset: 0) {          acc          value        }        f_acc: o_day(offset: -2) {          acc        }        ff_acc: o_day(offset: -3) {          acc        }      }    }    o_dma_topos {      id      dma      station      type      status      weight      o_station {        id        name        type        code        position        position_type        vip {          type          id        }        sensors {          id          name          unit          y_acc: o_day(offset: -1) {            acc            value          }          t_acc: o_day(offset: 0) {            acc            value          }          f_acc: o_day(offset: -2) {            acc          }          ff_acc: o_day(offset: -3) {            acc          }          o_realtime {            value            time          }        }      }    }  }}`,
  });
}
